// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PropertyCardContainer_wrapper__2e1PZ","offerCardDiv":"PropertyCardContainer_offerCardDiv__2k2Cq","offerInCard":"PropertyCardContainer_offerInCard__2iJu3"};